/* ContourLift™ – Slider, Vorher/Nachher-Vergleich, Akkordeon, Einblenden
   Ohne Abhängigkeiten. Funktioniert auch beim Neuladen von Sektionen im Theme-Editor. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Slider ---------- */
  if (!customElements.get('cl-slider')) {
    class ClSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-cl-track]');
        if (!this.track) return;
        this.prevs = this.querySelectorAll('[data-cl-prev]');
        this.nexts = this.querySelectorAll('[data-cl-next]');
        this.bar = this.querySelector('[data-cl-bar]');
        this.count = this.querySelector('[data-cl-count]');
        this._update = this.update.bind(this);
        this.track.addEventListener('scroll', this._update, { passive: true });
        this.prevs.forEach((b) => b.addEventListener('click', () => this.go(-1)));
        this.nexts.forEach((b) => b.addEventListener('click', () => this.go(1)));
        this.track.addEventListener('keydown', (e) => {
          if (e.target.closest('cl-compare')) return;
          if (e.key === 'ArrowRight') { e.preventDefault(); this.go(1); }
          if (e.key === 'ArrowLeft') { e.preventDefault(); this.go(-1); }
        });
        if ('ResizeObserver' in window) {
          this.ro = new ResizeObserver(this._update);
          this.ro.observe(this.track);
        }
        this.update();
      }
      disconnectedCallback() { if (this.ro) this.ro.disconnect(); }
      step() {
        var first = this.track.firstElementChild;
        if (!first) return this.track.clientWidth;
        var gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        return first.getBoundingClientRect().width + gap;
      }
      go(dir) {
        this.track.scrollBy({ left: dir * this.step(), behavior: reduce ? 'auto' : 'smooth' });
      }
      update() {
        var t = this.track;
        var max = t.scrollWidth - t.clientWidth;
        var p = max > 0 ? Math.min(1, Math.max(0, t.scrollLeft / max)) : 0;
        this.prevs.forEach((b) => (b.disabled = t.scrollLeft <= 2));
        this.nexts.forEach((b) => (b.disabled = t.scrollLeft >= max - 2));
        if (this.bar) {
          var vis = Math.min(1, t.clientWidth / t.scrollWidth);
          this.bar.style.width = vis * 100 + '%';
          this.bar.style.transform = 'translateX(' + p * (1 / vis - 1) * 100 + '%)';
        }
        if (this.count) {
          var n = t.children.length;
          var perView = Math.max(1, Math.round(t.clientWidth / this.step()));
          var i = p >= 0.995 ? n : Math.min(n, Math.round(t.scrollLeft / this.step()) + perView);
          this.count.textContent = String(i).padStart(2, '0') + ' / ' + String(n).padStart(2, '0');
        }
        this.toggleAttribute('data-static', max <= 2);
      }
    }
    customElements.define('cl-slider', ClSlider);
  }

  /* ---------- Vorher / Nachher ---------- */
  if (!customElements.get('cl-compare')) {
    class ClCompare extends HTMLElement {
      connectedCallback() {
        var range = this.querySelector('.cl-cmp__range');
        if (!range) return;
        var set = () => {
          var v = Number(range.value);
          this.style.setProperty('--pos', v + '%');
          this.toggleAttribute('data-pos-low', v < 14);
          this.toggleAttribute('data-pos-high', v > 86);
        };
        range.addEventListener('input', set);
        range.addEventListener('pointerdown', () => this.classList.add('is-dragging'));
        ['pointerup', 'pointercancel', 'blur'].forEach((ev) =>
          range.addEventListener(ev, () => this.classList.remove('is-dragging'))
        );
        set();
      }
    }
    customElements.define('cl-compare', ClCompare);
  }

  /* ---------- Akkordeon mit weicher Animation ---------- */
  if (!customElements.get('cl-accordion')) {
    class ClAccordion extends HTMLElement {
      connectedCallback() {
        this.querySelectorAll('details.cl-acc').forEach((d) => {
          if (d.dataset.clBound) return;
          d.dataset.clBound = '1';
          if (d.open) d.classList.add('is-open');
          var summary = d.querySelector('summary');
          var content = d.querySelector('.cl-acc__content');
          summary.addEventListener('click', (e) => {
            e.preventDefault();
            if (d._anim) d._anim.cancel();
            if (d.open) {
              d.classList.remove('is-open');
              summary.setAttribute('aria-expanded', 'false');
              if (reduce) { d.open = false; return; }
              d._anim = content.animate(
                [{ height: content.offsetHeight + 'px', opacity: 1 }, { height: '0px', opacity: 0 }],
                { duration: 340, easing: 'cubic-bezier(.4,0,.2,1)' }
              );
              d._anim.onfinish = () => { d.open = false; d._anim = null; };
            } else {
              if (this.hasAttribute('data-single')) {
                this.querySelectorAll('details.cl-acc[open]').forEach((o) => {
                  if (o !== d) { o.open = false; o.classList.remove('is-open'); o.querySelector('summary').setAttribute('aria-expanded', 'false'); }
                });
              }
              d.open = true;
              d.classList.add('is-open');
              summary.setAttribute('aria-expanded', 'true');
              if (reduce) return;
              d._anim = content.animate(
                [{ height: '0px', opacity: 0 }, { height: content.offsetHeight + 'px', opacity: 1 }],
                { duration: 420, easing: 'cubic-bezier(.22,.61,.36,1)' }
              );
              d._anim.onfinish = () => { d._anim = null; };
            }
          });
        });
      }
    }
    customElements.define('cl-accordion', ClAccordion);
  }

  /* ---------- Sanftes Einblenden ---------- */
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.cl [data-cl-reveal]:not(.is-in)');
    if (!els.length) return;
    (root || document).querySelectorAll('.cl').forEach((s) => s.classList.add('cl--js'));
    if (reduce || !('IntersectionObserver' in window) || document.documentElement.classList.contains('shopify-design-mode')) {
      els.forEach((el) => el.classList.add('is-in'));
      return;
    }
    var io = new IntersectionObserver((entries) => {
      entries.forEach((en) => {
        if (en.isIntersecting) {
          var el = en.target;
          el.style.transitionDelay = (Number(el.dataset.clDelay) || 0) + 'ms';
          el.classList.add('is-in');
          io.unobserve(el);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach((el) => io.observe(el));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initReveal());
  else initReveal();
  document.addEventListener('shopify:section:load', (e) => initReveal(e.target));
})();
